export default {
  headerContent: {
    title: 'Mapfre Sigorta Konut (Ev) Sigortası Fiyatları',
    slogan: "Konut Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'KONUT SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Mapfre Sigorta Konut Sigortası',
    description: {
      title: 'Mapfre Sigorta Konut Sigortası (Ev Sigortası) Nedir? ',
      content: [
        'Konut sigortası konutta oluşacak cam kılması, hırsızlık ve yer kayması gibi oluşacak risklere karşı koruma sağlamaktadır. Mapfre konut sigortası sigortalı binada oluşabilecek bu hasarlara karşı güvence sunmaktadır.'
      ]
    },
    subContent: {
      title: 'Mapfre Sigorta Konut Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'Konut sigortası teminatları ana ve ek olmak üzere ayrılmaktadır.',
          subList: [
            'Yangın, infilâk, yıldırım',
            'Grev, lokavt, kargaşalık, halk hareketleri, kötü niyetli hareketler, terör ',
            'Sel ve su baskını (seylap)',
            'Fırtına',
            'Kar ağırlığı',
            'Yer kayması',
            'Dahili su',
            'Duman',
            'Yakıt sızması',
            'Kara taşıtları çarpması',
            'Hava taşıtları çarpması',
            'Deniz taşıtları çarpması',
            'Enkaz kaldırma masrafları',
            'Hırsızlık',
            'Kazaen kırılma',
            'Cam ve ayna kırılması',
            'Yangın mali mesuliyet',
            'Kira kaybı',
            'Alternatif ikamet ve taşınma masrafları',
            'Üçüncü şahıs mali mesuliyet',
            'Sabit dekorasyon',
            'Elektronik cihaz teminatı',
            'Gasp, kapkaç, yankesicilik teminatı',
            'Konut dışında bulunan eşyalar teminatı',
            'Konutta bulunan üçüncü şahıslara ait eşyalar teminatı',
            'Konut adaptasyon',
            'Deprem (İsteğe bağlı teminat olup sigortalının talep etmesi durumunda poliçe kapsamına dahil edilmektedir.)',
            'Ev yardım hizmetleri (sınırsız-limitsiz)',
            'Enflasyon korunma avantajını içerir.'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Konut Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Konut Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Konut Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Konut Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Konut Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Mapfre Sigorta Konut Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
